import { render } from "./TablesOfContent.vue?vue&type=template&id=0969d10a&ts=true"
import script from "./TablesOfContent.vue?vue&type=script&lang=ts"
export * from "./TablesOfContent.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__